<svg
  class="icon-external-link"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3.99967 2.66634C3.2633 2.66634 2.66634 3.2633 2.66634 3.99967V11.9997C2.66634 12.7361 3.26329 13.333 3.99967 13.333H11.9997C12.7361 13.333 13.333 12.7361 13.333 11.9997V10.6663C13.333 10.2982 13.6315 9.99967 13.9997 9.99967C14.3679 9.99967 14.6663 10.2982 14.6663 10.6663V11.9997C14.6663 13.4724 13.4724 14.6663 11.9997 14.6663H3.99967C2.52692 14.6663 1.33301 13.4724 1.33301 11.9997V3.99967C1.33301 2.52692 2.52692 1.33301 3.99967 1.33301H5.33301C5.7012 1.33301 5.99967 1.63148 5.99967 1.99967C5.99967 2.36786 5.7012 2.66634 5.33301 2.66634H3.99967Z"
    [attr.fill]="color"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8.66667 1.99967C8.66667 1.63148 8.96514 1.33301 9.33333 1.33301H14C14.3682 1.33301 14.6667 1.63148 14.6667 1.99967V6.66634C14.6667 7.03453 14.3682 7.33301 14 7.33301C13.6318 7.33301 13.3333 7.03453 13.3333 6.66634V3.60915L7.13807 9.80441C6.87772 10.0648 6.45561 10.0648 6.19526 9.80441C5.93491 9.54406 5.93491 9.12195 6.19526 8.8616L12.3905 2.66634H9.33333C8.96514 2.66634 8.66667 2.36786 8.66667 1.99967Z"
    [attr.fill]="color"
  />
</svg>
